export { apiClient, setAccessTokenGetter, buildQueryString } from './client';
export { ApiError, isApiError, getErrorMessage } from './errors';

// Import API services
import { connectorsApi } from './connectors';
import { runsApi } from './runs';
import { sasApi } from './sas';
import { settingsApi } from './settings';
import { healthApi } from './health';
import { allowlistApi } from './allowlist';

// Re-export individual API services
export { connectorsApi, runsApi, sasApi, settingsApi, healthApi, allowlistApi };

// Re-export all API services as a single object for convenience
export const api = {
  connectors: connectorsApi,
  runs: runsApi,
  sas: sasApi,
  settings: settingsApi,
  health: healthApi,
  allowlist: allowlistApi,
} as const;
